export default __webpack_public_path__ + "static/media/sugar_drops.d8fd089f.svg";